import { STEP_COOKIE_KEY } from "@/constants";
import { StepType } from "@/types/routes";

export const readStepCookie = (): StepType | undefined => {
	if (typeof document === "undefined") return undefined;

	const match = document.cookie
		.split("; ")
		.find((row) => row.startsWith(`${STEP_COOKIE_KEY}=`));

	return match?.split("=")[1] as StepType | undefined;
};
